import React, { useEffect, useMemo, useRef, useState } from "react";
import "datatables.net-bs4";
import { Link } from "react-router-dom";
import { useAgents } from "../../utils/agents";
import { NavItem, NavTabs } from "../layout/Nav";
import moment from "moment";
import { FaUserCircle } from "react-icons/fa";
import { FaPhoneSlash, FaTrash } from "react-icons/fa";

import SearchSVG from "../../assets/icons/search-icon.svg"
export default function AgentInboxesContent() {
    const { agents, loaded, deleteCallByIdWithToken } = useAgents();
    const [selectedAgentId, setSelectedAgentId] = useState(() => (
        typeof window !== "undefined"
            ? window.localStorage.getItem("selectedAgentId") || ""
            : ""
    ));
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [messageToDelete, setMessageToDelete] = useState(null);
    const [loadingDelete, setLoadingDelete] = useState(false);

    useEffect(() => {
        console.log("selectedMessage updated:", selectedMessage);
    }, [selectedMessage]);

    const audioRef = useRef(null);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.load();
        }
    }, [selectedMessage]);

    const agentsArray = useMemo(() => (
        Array.isArray(agents)
            ? agents
            : Object.keys(agents).map((key) => ({
                id: key,
                ...agents[key],
            }))
    ), [agents]);

    useEffect(() => {
        if (agentsArray.length === 0) return;
        const hasSelectedAgent = agentsArray.some((agent) => agent.id === selectedAgentId);
        if (!hasSelectedAgent) {
            setSelectedAgentId(agentsArray[0].id);
        }
    }, [agentsArray, selectedAgentId]);

    useEffect(() => {
        if (!selectedAgentId || typeof window === "undefined") return;
        window.localStorage.setItem("selectedAgentId", selectedAgentId);
    }, [selectedAgentId]);

    useEffect(() => {
        setSelectedMessage(null);
        setSearchTerm("");
    }, [selectedAgentId]);

    const selectedAgent = useMemo(() => (
        agentsArray.find((agent) => agent.id === selectedAgentId) || agentsArray[0]
    ), [agentsArray, selectedAgentId]);

    if (!loaded) {
        return (
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                    <div className="">
                        <div className="kt-portlet__body">
                            <div className="text-center">Chargement...</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const getInitials = (name) => {
        return name.split(" ").map((n) => n[0]).join("").toUpperCase();
    };

    const filteredMessages = selectedAgent?.calls?.filter((msg) =>
        msg?.customer?.number?.toString().includes(searchTerm) ||
        msg?.summary?.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];
    

    const handleDeleteClick = (e, msg) => {
        e.stopPropagation();
        setMessageToDelete(msg);
        setShowDeleteModal(true);
      };
      
      const confirmDelete = async () => {
        setLoadingDelete(true); // Start loading
        try {
            await deleteCallByIdWithToken(messageToDelete.id);
            setShowDeleteModal(false);
        } catch (error) {
            console.error("Error deleting call:", error);
        } finally {
            setLoadingDelete(false); // Stop loading
        }
    };


    return (
        <div className="body-container">
            <div>
                <h3 className="title">Agents</h3>
                {selectedAgent && (
                    <div className="d-flex justify-content-between align-items-center title-container mb-4">
                        <NavTabs className="titles">
                            <NavItem className="active">
                                <Link to="/agents">Inbox</Link>
                            </NavItem>
                            <NavItem>
                                <Link to="/settings">Settings</Link>
                            </NavItem>
                        </NavTabs>
                        <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
                            <label className="mb-0 text-muted" htmlFor="agent-selector-inbox">Agent</label>
                            <select
                                id="agent-selector-inbox"
                                className="form-control"
                                style={{ minWidth: "240px" }}
                                value={selectedAgent.id}
                                onChange={(e) => setSelectedAgentId(e.target.value)}
                            >
                                {agentsArray.map((agentItem) => (
                                    <option key={agentItem.id} value={agentItem.id}>
                                        {agentItem.label || agentItem.businessName || agentItem.twilioPhoneNumber}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
            </div>

            {selectedAgent ? (
                <div className="d-flex bg-light _calls-container">
                    <div
                        className={`w-100 w-md-25 border-end bg-white d-flex flex-column max-w-350 ${selectedMessage ? "d-none d-md-flex" : "d-flex"
                            }`}

                    >
                        <div className="input-group px-3 mb-3">
                            <span className="input-group-text">
                                <img src={SearchSVG} alt="SearchSVG" />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="flex-grow-1 overflow-auto mx-2">
                            {filteredMessages?.length === 0 ? (
                                <p className="text-muted text-center">No messages found</p>
                            ) : (
                                <ul className="list-group">
                                    {filteredMessages.map((msg) => (
                                        <li
                                            key={msg.id}
                                            className={`list-group-item list-group-item-action d-flex align-items-center cursor-pointer ${selectedMessage?.id === msg.id ? "active bg-primary text-white" : ""
                                                }`}
                                            onClick={() => setSelectedMessage(msg)}
                                        >
                                            <div className="me-2">
                                                <FaUserCircle size={40} />
                                            </div>
                                            <div className="flex-grow-1">
                                                <strong>{msg?.customer?.number}</strong>
                                                <p className={`mb-0 ${selectedMessage?.id === msg.id ? "text-white" : "text-muted"}`}>
                                                    {msg.summary?.length > 30 ? `${msg.summary.substring(0, 30)}...` : msg.summary}
                                                </p>

                                            </div>
                                            <span className={`ms-auto end ${selectedMessage?.id === msg.id ? "text-white" : "text-muted"}`}>
                                                {moment(msg.createdAt).format("hh:mm A")}
                                            </span>

                                            <FaTrash className="text-danger cursor-pointer ml-2" onClick={(e) => handleDeleteClick(e, msg)} />
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    {/* Message Detail */}
                    <div className="flex-grow-1 p-4 bg-white shadow-sm d-flex flex-column">
                        {!selectedMessage ? (
                            <div className="d-flex flex-column align-items-center justify-content-center text-center h-100">
                                <FaPhoneSlash size={50} className="text-muted mb-3" />
                                <p className="text-muted">Select a call to view details</p>
                            </div>
                        ) : (
                            <div className="overflow-auto">
                                <button className="btn btn-outline-secondary mb-3 d-md-none" onClick={() => setSelectedMessage(null)}>Back</button>
                                <div className="d-flex align-items-center mb-3">
                                    <div
                                        className="rounded-shape me-3"
                                    >
                                        {getInitials(selectedMessage?.customer?.number)}
                                    </div>
                                    <div>
                                        <p>{selectedMessage?.customer?.number}</p>
                                    </div>
                                </div>
                                <hr />
                                <p className="text-muted">Answered by: <span className="font-normal">{selectedAgent?.twilioPhoneNumber}</span></p>
                                <p className="text-muted mt-2">Recording:</p>
                                <audio controls ref={audioRef}>
                                    <source src={selectedMessage?.recordingUrl} type="audio/wav" />
                                    Your browser does not support the audio element.
                                </audio>
                                <p className="text-muted mt-4">Message:</p>
                                <p>{selectedMessage?.summary}</p>

                                <div className="mt-4 border-top pt-3">
                                    <h5 className="mb-3">Transcript</h5>
                                    <div className="p-3 border rounded bg-light">
                                        {selectedMessage?.transcript ? (
                                            selectedMessage.transcript
                                                .split("\n")
                                                .filter(line => line.trim() !== "") // Remove empty lines
                                                .map((line, index) => (
                                                    <p key={index} className={line.startsWith("AI:") ? "text-primary" : "text-success"}>
                                                        <strong>{line.startsWith("AI:") ? "AI: " : "User: "}</strong> {line.replace(/^AI: |^User: /, "")}
                                                    </p>
                                                ))
                                        ) : (
                                            <p className="text-muted">No transcript available.</p>
                                        )}
                                    </div>
                                </div>

                                <p className="text-muted mt-4">
                                    <strong>Date:</strong> {moment(selectedMessage?.createdAt).format("DD-MM-YYYY")}
                                </p>
                            </div>

                        )}
                    </div>
                </div>
            ) : (
                <div className="kt-portlet kt-portlet--tabs">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">Aucun Agent Trouvé</h3>
                        </div>
                    </div>
                    <div className="kt-portlet__body">
                        <div className="text-center">
                            <Link
                                to="/add-agent"
                                className="btn btn-brand btn-elevate btn-icon-sm text-nowrap"
                            >
                                Créer un agent
                            </Link>
                        </div>
                    </div>
                </div>
            )}

            {showDeleteModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content px-2"  style={{ borderRadius: "20px" }}>
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Deletion</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => setShowDeleteModal(false)}
                                ></button>

                            </div>
                            <div className="modal-body">
                            <p>Are you sure you want to delete this message? You won’t be able to undo this action.</p>


                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowDeleteModal(false)}
                                >
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-danger" onClick={confirmDelete} disabled={loadingDelete}>
                                    {loadingDelete ? <span className="spinner-border spinner-border-sm"></span> : "Delete"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}
